import { render, staticRenderFns } from "./recommandations2.vue?vue&type=template&id=667948dc&scoped=true&"
import script from "./recommandations2.vue?vue&type=script&lang=js&"
export * from "./recommandations2.vue?vue&type=script&lang=js&"
import style0 from "./recommandations2.vue?vue&type=style&index=0&id=667948dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667948dc",
  null
  
)

export default component.exports